// extracted by mini-css-extract-plugin
module.exports = {"repliesWrapper":"postDetailStyles_repliesWrapper__MjZuW"};